export default {
	gl_sub_service_title: {
		en: "Select Services you want to opt for",
		ar: "اختر الخدمات التي ترغب بإختيارها"
	},
	gl_sub_service_info: {
		en: "You can now select the property type, area and the budget (only for Buy and Lease Property)",
		ar: "يمكنك الآن اختيار نوع العقار و المساحة و المبلغ ( لبيع و ايجار العقارات فقط )"
	},
	gl_all_services: {
		en: "All Services",
		ar: "جميع الخدمات"
	},
	gl_sell_property: {
		en: "Sell Property",
		ar: "بيع العقار",
	},
	gl_buy_property: {
		en: "Buy Property",
		ar: "شراء عقارات",
	},
	gl_lease_property: {
		en: "Lease Property",
		ar: "ايجار عقار"
	},
	gl_green_list_information: {
		en: "Green List Information",
		ar: "معلومات القائمة الخضراء"
	},
	gl_budget: {
		en: "Budget",
		ar: "الميزانية"
	},
	gl_min_aed: {
		en: "Min (AED)",
		ar: "القيمة الصغرى (درهم)"
	},
	gl_max_aed: {
		en: "Max (AED)",
		ar: "القيمة العظمى (درهم)"
	},
	gl_subscribe: {
		en: "Subscribe",
		ar: "يشترك"
	},
	gl_verify_and_subscribe: {
		en: "Verify and Subscribe",
		ar: "التحقق و الإشتراك"
	},
	gl_all_areas: {
		en: "All areas",
		ar: "كل  المناطق"
	},
	gl_any_property_type: {
		en: "All property types",
		ar: "كل أنواع العقارات"
	},
};
